import { createAction, props } from '@ngrx/store';

export const loadNotificationRemove = createAction('[NotificationRemove] Load NotificationRemove', props<{ userNotificationId: string }>());

export const loadNotificationRemoveSuccess = createAction(
  '[NotificationRemove] Load NotificationRemove Success',
  props<{ response: string }>()
);

export const loadNotificationRemoveFailure = createAction('[NotificationRemove] Load NotificationRemove Failure', props<{ error: any }>());
